import { ChangeDetectionStrategy, Component, EventEmitter, Output } from '@angular/core';

@Component({
  selector: 'app-go-green-opt-out',
  template: `
    <h1>Opt Out of Go Green</h1>

    <p>
      By opting out of Go Green you will stop receiving electronic notification of documents. If no other borrowers on your loan are opted
      in for Go Green you will also begin receiving printed copies of documents in the mail.
    </p>

    <button class="btn btn-primary opt-out" (click)="optOut.emit()">Opt Out</button>
  `,
  styles: [
    `
      .opt-out {
        margin-left: 10px;
      }
    `,
  ],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class GoGreenOptOutComponent {
  @Output() optOut = new EventEmitter<void>();
}
